"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.setSortInfo = void 0;
const model_1 = require("../../model");
const types_1 = require("../../types");
const selectors_1 = require("../../exports/store/selectors");
const i18n_1 = require("../../exports/i18n");
const command_manager_1 = require("../../command_manager");
const config_1 = require("../../config");
exports.setSortInfo = {
    undoable: true,
    execute: (context, options) => {
        const { model: state } = context;
        const { data, viewId, applySort } = options;
        const datasheetId = (0, selectors_1.getActiveDatasheetId)(state);
        const datasheet = (0, selectors_1.getDatasheet)(state, datasheetId);
        const fieldIds = (0, selectors_1.getCurrentView)(state, datasheetId).columns.map(item => item.fieldId);
        const fieldPermissionMap = (0, selectors_1.getFieldPermissionMap)(state, datasheetId);
        if (!state || !datasheet) {
            return null;
        }
        const hasInvalidSort = data && data.rules.some(sortField => {
            const fieldRole = (0, selectors_1.getFieldRoleByFieldId)(fieldPermissionMap, sortField.fieldId);
            // If the column permission is set, the current column does not exist in the view data, so ignore this situation
            if (fieldRole === config_1.ConfigConstant.Role.None) {
                return false;
            }
            return !fieldIds.includes(sortField.fieldId);
        });
        // Determine whether the FieldId of the current operation exists or not
        if (hasInvalidSort) {
            throw new Error((0, i18n_1.t)(i18n_1.Strings.error_sorted_failed_the_field_not_exist));
        }
        // Determine whether the currently operating view is the active view
        if (datasheet.activeView !== viewId) {
            throw new Error((0, i18n_1.t)(i18n_1.Strings.error_sorted_failed_wrong_target_view));
        }
        const actions = [];
        const setSortInfoAction = model_1.DatasheetActions.setViewSort2Action(state, datasheet.snapshot, { viewId, sortInfo: data, applySort });
        // action && collected.push(action);
        setSortInfoAction && actions.push(...setSortInfoAction);
        if (actions.length === 0) {
            return null;
        }
        return {
            result: command_manager_1.ExecuteResult.Success,
            resourceId: datasheetId,
            resourceType: types_1.ResourceType.Datasheet,
            actions,
        };
    },
};
/*

 declare module '../../command_manager/command_manager' {
 interface CollaCommandManager {
 execute(options: ISetRecordsOptions & { cmd: 'SetRecords' });
 }
 }

 */
//# sourceMappingURL=set_sort_info.js.map